/**
 * Initial auth state.
 */
export const initialAuthState = {
  isAuthenticated: false,
  isLoading: typeof window !== 'undefined',
  redirectInProgress: false,
  error: null,
};
